// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  dirty: true,
  raw: '53487269-dirty',
  hash: '53487269',
  distance: null,
  tag: null,
  semver: null,
  suffix: '53487269-dirty',
  semverString: null,
  version: '0.0.0',
};
/* tslint:enable */
